import { z } from 'zod';

export const ORDER_VIEWS = ['all', 'open', 'on_hold', 'results', 'closed'] as const;
export type OrderView = (typeof ORDER_VIEWS)[number];

/** URL search params of the orders list. Invalid values fall back to the defaults. */
export const ordersSearchSchema = z.object({
  view: z.enum(ORDER_VIEWS).optional().catch(undefined),
  provider: z.enum(['UHG', 'EQP']).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  size: z
    .union([z.literal(10), z.literal(25), z.literal(50)])
    .optional()
    .catch(undefined),
  q: z
    .union([z.string(), z.number()])
    .transform((v) => String(v).trim())
    .pipe(z.string().min(1).max(100))
    .optional()
    .catch(undefined),
});
export type OrdersSearch = z.infer<typeof ordersSearchSchema>;

/** `/medical-orders/new?policy=…` pre-fills the policy lookup. */
export const newOrderSearchSchema = z.object({
  policy: z
    .union([z.string(), z.number()])
    .transform((v) => String(v).trim())
    .pipe(z.string().min(1).max(40))
    .optional()
    .catch(undefined),
});
export type NewOrderSearch = z.infer<typeof newOrderSearchSchema>;
